export function saveCurrentSurveyDataLocal({ commit }, payload) {
  commit('setAgreementId', payload.agreementId);
  commit('setYear', payload.year);
  commit('setContractCode', payload.contractCode);
  commit('setProductComponentCodesToIgnore', payload.componentCodesToIgnore);
  commit('setNewlyParticipantCustomerNumbers', payload.newlyParticipantCustomerNumbers ?? []);
}

export async function validateCards({ dispatch, rootGetters }, payload) {
  let success = false;
  const newValue = payload;

  if (newValue?.disabled !== true) {
    const cards = rootGetters['contract/contracts'].allCards;

    const card = cards.find(
      (card) =>
        (card.productComponentCode === newValue?.key &&
          card.packageTypeForWebApplications.productType === newValue.productType) ||
        (card.productComponentCode == null && card.packageTypeForWebApplications.productType === newValue.productType),
    );

    if (card) {
      const payload = {
        customerNumber: newValue.name,
        card: card,
        typeOfProduct: card.packageTypeForWebApplications,
      };

      await dispatch('contract/updateCardSelectionStatus', payload, { root: true });
      await dispatch('contract/validateContract', null, { root: true });
      success = true;
    }
  }

  return success;
}

export async function validateDentalInsurance({ commit, dispatch, getters, rootGetters }, payload) {
  var medicalSelectionDetails = rootGetters['contract/contracts'].customerMedicalSelectionDetails.filter(
    (x) => Number(x.customerNumber) === payload.newValue.name,
  );

  //No medical selection details then not needed to validate.
  if (medicalSelectionDetails.length > 0) {
    const customer = rootGetters['contract/contracts'].customers.find(
      (x) => Number(x.customerNumber) === payload.newValue.name,
    );

    const customerPolicyNumber = rootGetters['agreement/agreementDetails']
      .find((detail) => detail.agreementId === getters.getAgreementId)
      .agreementParticipants.find((x) => Number(x.customer.customerNumber) === payload.newValue.name)?.policyNumber;

    if (medicalSelectionDetails.some((x) => x.hasDeniedMedicalSelection)) {
      commit('setDenialReasonData', {
        fullName: customer.fullName,
        birthDate: customer.birthDate,
      });
      commit('setShowDenialReason', true);
      await dispatch('validateCards', payload.oldValue);
    } else if (!medicalSelectionDetails.some((x) => x.medicalSelectionDateIsToday)) {
      const data = {
        customer: {
          fullName: customer.fullName,
          birthDate: customer.birthDate,
          customerNumber: customer.customerNumber,
          policyNumber: customerPolicyNumber,
        },
        oldValue: payload.oldValue,
        newValue: payload.newValue,
      };

      commit('setCurrentMedicalSelectionData', data);
      commit('setShowMedicalSelectionOverlay', true);
    }
  }
}

export async function closeDenialReason({ commit }) {
  commit('setShowDenialReason', false);
  commit('setDenialReasonData', undefined);
}

export async function closeRejected({ commit }) {
  commit('setShowRejected', false);
  commit('setRejectedData', undefined);
}

export async function cancelMedicalSelection({ commit, dispatch, getters }) {
  const data = getters.getMedicalSelectionOverlayData;

  commit('setShowMedicalSelectionOverlay', false);

  await dispatch('validateCards', data.oldValue);

  commit('setCurrentMedicalSelectionData', undefined);
}

export async function validateMedicalSelection({ commit, dispatch, getters, rootGetters }, payload) {
  const customerNumber = getters.getMedicalSelectionOverlayData.customer.customerNumber;

  let success = false;

  if (!payload.newlyInsuredPersons) {
    await dispatch(
      'agreement/updateMedicalSelectionForAgreementParticipant',
      {
        agreementId: getters.getAgreementId,
        customerNumber: customerNumber,
        policyNumber: getters.getMedicalSelectionOverlayData.customer.policyNumber,
        medicalSelection: payload.medicalSelection,
      },
      { root: true },
    );
  }

  await dispatch(
    'contract/saveMedicalSelections',
    {
      agreementDetails: rootGetters['agreement/agreementDetails']
        .find((detail) => detail.agreementId === getters.getAgreementId)
        .mapToBackendModel(),
      newlyInsuredPersons: payload.newlyInsuredPersons,
    },
    { root: true },
  );

  if (
    !rootGetters['contract/medicalSelectionResponse']?.customerMedicalSelectionDetails?.find(
      (x) => x.customer.customerNumber === customerNumber,
    )?.isApproved
  ) {
    commit('setShowRejected', true);
    commit('setRejectedData', {
      fullName: getters.getMedicalSelectionOverlayData.customer.fullName,
      birthDate: getters.getMedicalSelectionOverlayData.customer.birthDate,
      packageName: getters.getMedicalSelectionOverlayData.newValue.value,
    });
    await dispatch('cancelMedicalSelection');
  } else {
    commit('setShowMedicalSelectionOverlay', false);
    commit('setCurrentMedicalSelectionData', undefined);
    success = true;
  }

  return success;
}
